import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog'
import { useTranslation } from '../../locale/useTranslation'
import { EditPageHeader } from '../../components/EditPageHeader';
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import ToastNotification from '../../components/ToastNotification';

const AutoSegmentRulesEditForm = (props) => {
    const lang = useTranslation();


    const calculateSegmentDetails = (segmentType) => {
        if (!segmentType || !segmentType.Description) return "";
        const count = parseInt(segmentType.Description);
        if (!count || count <= 0) return "";
        const each = Math.floor(100 / count);
        let arr = [];
        for (let i = 0; i < count; i++) {
            arr.push(each);
        }

        return arr.join(", ");
    };

    const blankDataItem = {
        ...props?.item,
        SlotDuration: props?.item?.SlotDuration ? utility.convertMilisecondsToStringWithFrames(props?.item?.SlotDuration) : "00:00:00:00",
        Description: props?.item?.copy ? "Copy of " + props?.item?.Description : props?.item?.Description ?? "",
        Archive: props?.item?.Archive ?? false,
        SegmentType: props?.item?.SegmentType ?? {},
        SegmentDetails: props?.item?.SegmentDetails ? props?.item?.SegmentDetails : calculateSegmentDetails(props?.item?.SegmentType),
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [segmentTypes, setSegmentTypes] = useState([]);

    useEffect(() => {
        loadCombo()
    }, [])

    const loadCombo = async () => {
        let segmentTypeRes = await API.getDataLookup(ENTITYNAME.SegmentType, { sort: { Description: 1 } });
        setSegmentTypes(segmentTypeRes.data)
    }

    const onChange = (e) => {
        if (e.target?.name === "SegmentType" || e.name === "SegmentType") {
            const value = e.value;
            const details = calculateSegmentDetails(value);
            setDataItem({ ...dataItem, SegmentType: value, SegmentDetails: details });
        }

        else if (e.target?.name === "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const isValid = () => {

        if (!dataItem.Description) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }

        if (dataItem.SegmentDetails) {

            let arr = dataItem.SegmentDetails.split(",").map(x => parseFloat(x.trim()) || 0);
            let total = arr.reduce((sum, val) => sum + val, 0);

            if (dataItem?.SegmentType?.SegmentCount) {
                if (arr.length !== dataItem?.SegmentType?.SegmentCount) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.segment_details_should_be_equal_to_segment_count });
                    return false;
                }
            }
            if (total > 100) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.segment_details_total_should_not_be_greater_than_100_percentage });
                return false;
            }
        }

        return true;
    };


    const handleSubmit = async () => {
        if (!isValid()) return;
        var slotDuration = utility.convertStringWithFramesToMilliseconds(dataItem.SlotDuration);
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Description: dataItem?.Description,
            Archive: dataItem?.Archive ?? false,
            SegmentType: dataItem?.SegmentType && Object.keys(dataItem?.SegmentType).length > 0 ? {
                SID: dataItem?.SegmentType?.SID,
                Description: dataItem?.SegmentType?.Description,
                SegmentCount: dataItem?.SegmentType?.SegmentCount
            } : {},
            SlotDuration: slotDuration,
            SegmentDetails: dataItem?.SegmentDetails,
            checkDuplicate: true,
            query: [["Description", "=", dataItem.Description]]

        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.AutoSegmentRules, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.AUTO_SEGMENT_RULE, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.AutoSegmentRules);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <BossDialog title={props.item.Description ?? lang.auto_segment_rule_dialog_header} onClose={props.cancelEdit} width={"600px"}>
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className='row mt-2'>
                <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input name="Description" type="text" onChange={onChange} value={dataItem.Description} className="form-control form-control-sm" />
                </div>
                <div className="col-6">
                    <label>{lang.segment_type_label}</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={segmentTypes}
                        name="SegmentType"
                        textField="Description"
                        dataItemKey="SID"
                        value={dataItem.SegmentType}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className="col-6">
                    <label htmlFor="">{lang.slot_duration_label}</label>
                    <TimePickerWithFormat
                        className="form-control form-control-sm"
                        name="SlotDuration"
                        value={dataItem.SlotDuration}
                        onChange={onChange}
                        required
                    />
                </div>
                <div className='col-6'>
                    <label>{lang.segment_details_label}</label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        name="SegmentDetails"
                        onChange={onChange}
                        value={dataItem.SegmentDetails}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-6'>
                    <input
                        style={{ border: "1px solid grey", marginTop: "26px" }}
                        name={"Archive"}
                        type='checkbox'
                        onChange={onChange}
                    />
                    <label className="ml-2">{lang.archive}</label>
                </div>
            </div>

        </BossDialog>
    )
}

export default AutoSegmentRulesEditForm